export const endpoints = {
  files: '/files',
  file: '/files/{id}',
} as const;
